"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supplant = exports.reduce = exports.find = exports.get = exports.mergeWith = exports.merge = exports.omit = exports.isString = exports.isNil = exports.defaultTo = exports.isUuid = exports.defaultToAny = void 0;
var defaultToAny = function (value) {
    var defaultValues = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        defaultValues[_i - 1] = arguments[_i];
    }
    return (0, exports.reduce)(defaultValues, exports.defaultTo, value);
};
exports.defaultToAny = defaultToAny;
var isUuid = function (uuid) {
    var v4Regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return v4Regex.test(uuid);
};
exports.isUuid = isUuid;
// Copied lodash implementation
var defaultTo = function (value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value;
};
exports.defaultTo = defaultTo;
// Copied lodash implementation
var isNil = function (value) {
    return value == null;
};
exports.isNil = isNil;
// Custom implementation
var isString = function (value) {
    return typeof value === 'string' || value instanceof String;
};
exports.isString = isString;
// Custom implementation
var omit = function (obj, keysToOmit) {
    if (!obj)
        return {};
    var keysArray = Array.isArray(keysToOmit) ? keysToOmit : [keysToOmit];
    return Object.keys(obj)
        .filter(function (key) { return !keysArray.includes(key); })
        .reduce(function (result, key) {
        result[key] = obj[key];
        return result;
    }, {});
};
exports.omit = omit;
// Custom implementation
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
function baseMerge(target, sources, customizer) {
    for (var _i = 0, sources_1 = sources; _i < sources_1.length; _i++) {
        var source = sources_1[_i];
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                var srcValue = source[key];
                var tgtValue = target[key];
                // If a customizer is provided, let it decide how to merge
                var result = customizer ? customizer(tgtValue, srcValue, key, target, source) : undefined;
                if (result === undefined) {
                    // Default merging behavior
                    if (srcValue && typeof srcValue === 'object' && !Array.isArray(srcValue) &&
                        tgtValue && typeof tgtValue === 'object' && !Array.isArray(tgtValue)) {
                        baseMerge(tgtValue, [srcValue], customizer);
                    }
                    else {
                        if ((srcValue !== undefined && srcValue !== null) || !target[key]) {
                            target[key] = srcValue;
                        }
                    }
                }
                else {
                    target[key] = result;
                }
            }
        }
    }
    return target;
}
// Custom implementation
var merge = function (target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    return baseMerge(target, sources);
};
exports.merge = merge;
// Custom implementation
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
var mergeWith = function (target, customizer) {
    var sources = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        sources[_i - 2] = arguments[_i];
    }
    return baseMerge(target, sources, customizer);
};
exports.mergeWith = mergeWith;
// Custom implementation
var get = function (object, path, defaultValue) {
    if (object == null)
        return defaultValue;
    // Convert path to an array if it's not already
    var keys = Array.isArray(path) ? path : path.split('.');
    var result = object;
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        if (result == null || typeof result !== 'object' || !(key in result)) {
            return defaultValue;
        }
        result = result[key];
    }
    return result === undefined ? defaultValue : result;
};
exports.get = get;
// Custom implementation
var find = function (collection, predicate) {
    if (Array.isArray(collection)) {
        // Iterate over array elements
        for (var i = 0; i < collection.length; i++) {
            var value = collection[i];
            if (predicate(value, i, collection)) {
                return value;
            }
        }
    }
    else if (collection && typeof collection === 'object') {
        // Iterate over object properties
        for (var key in collection) {
            if (Object.prototype.hasOwnProperty.call(collection, key)) {
                var value = collection[key];
                if (predicate(value, key, collection)) {
                    return value;
                }
            }
        }
    }
    return undefined; // If no match found
};
exports.find = find;
// Custom implementation
var reduce = function (collection, iteratee, accumulator) {
    var isArray = Array.isArray(collection);
    // Convert the collection into a list of [key, value] pairs to handle both objects and arrays uniformly.
    var entries = isArray
        ? collection.map(function (value, index) { return [index, value]; })
        : Object.entries(collection);
    var startIndex = 0;
    // If no accumulator is provided, use the first element
    // and adjust the starting index or key
    if (accumulator === undefined) {
        if (entries.length === 0) {
            // If the collection is empty and no accumulator is provided, return undefined
            return undefined;
        }
        // Use the first element of the collection as the accumulator
        accumulator = entries[0][1];
        startIndex = 1;
    }
    // Iterate over the collection starting from the determined index
    for (var i = startIndex; i < entries.length; i++) {
        var _a = entries[i], keyOrIndex = _a[0], value = _a[1];
        accumulator = iteratee(accumulator, value, keyOrIndex, collection);
    }
    return accumulator;
};
exports.reduce = reduce;
// Custom implementation
var supplant = function (string, replacements) {
    return string.replace(/\$\{([^}]+)\}/g, function (match, key) {
        var replacementValue = replacements[key];
        return typeof replacementValue === 'string' || typeof replacementValue === 'number'
            ? replacementValue
            : match;
    });
};
exports.supplant = supplant;
//# sourceMappingURL=Utility.js.map